var map = {
	"./2.svg": 21852,
	"./AboutUs-Vector.svg": 92073,
	"./AboutUs-log.svg": 25563,
	"./AboutUs-text.svg": 94733,
	"./AlchemyInstitute-gold.svg": 67546,
	"./Announcement-game.svg": 30500,
	"./Announcement-sousuo.svg": 77845,
	"./BusinessCopyright-footimg.svg": 53598,
	"./CastingStatus-no.svg": 27695,
	"./CastingStatus-ok.svg": 88772,
	"./CollectCards-boring.svg": 86491,
	"./CollectCards-question.svg": 38390,
	"./CollectCards-top.svg": 54059,
	"./CollectionSynthesis-boot.svg": 693,
	"./CollectionSynthesis-group.svg": 22671,
	"./CollectionSynthesis-img.svg": 87263,
	"./CollectionSynthesis-line.svg": 1705,
	"./CollectionSynthesis-line2.svg": 29675,
	"./CollectionSynthesis-pho.svg": 21620,
	"./CornerstoneCard-img.svg": 11509,
	"./EditAddress-lj.svg": 77882,
	"./Frame 1171275067.svg": 44785,
	"./GameIntroduction-trophy.svg": 37617,
	"./Gold.svg": 41050,
	"./Group.svg": 35831,
	"./Group1.svg": 69224,
	"./HarvestAddress-add.svg": 31903,
	"./HarvestAddress-bj1.svg": 59508,
	"./HarvestAddress-bj2.svg": 88734,
	"./IncreaseByTransferring-arrow-right.svg": 85746,
	"./IncreaseByTransferring-more-line.svg": 69463,
	"./InviteRankingList-Ellipse.svg": 62668,
	"./InviteRankingList-fill.svg": 72002,
	"./InviteRankingList-img.svg": 59159,
	"./Mushroom.svg": 75940,
	"./MyGem-gem.svg": 51048,
	"./MySpiritualGold-small.svg": 65657,
	"./Newspaper.svg": 24423,
	"./NftDetail-grade.svg": 77799,
	"./NoticeDetails-img.svg": 44680,
	"./NoticeDetails-line.svg": 79440,
	"./OnChainInformation-img.svg": 11258,
	"./OnChainInformation-img2.svg": 87681,
	"./OrderPayment-fill.svg": 21107,
	"./OrderPayment-fill2.svg": 1490,
	"./OrderPayment-line.svg": 52611,
	"./OrderPayment-title.svg": 49929,
	"./Pager.svg": 8438,
	"./Party popper.svg": 20106,
	"./PaymentPage-group.svg": 70571,
	"./PaymentPage-img.svg": 45919,
	"./PaymentPage-no.svg": 92218,
	"./PaymentPage-ok.svg": 44856,
	"./PaymentPage-right-line.svg": 76375,
	"./PaymentPage-right.svg": 32833,
	"./PaymentPage-small.svg": 13056,
	"./PaymentPage-title-img.svg": 7062,
	"./PaymentPage-wait.svg": 29002,
	"./PersonalSetting-eye.svg": 72448,
	"./PersonalSetting-eye2.svg": 12997,
	"./PersonalSetting-qq.svg": 66579,
	"./PersonalSetting-weix.svg": 71737,
	"./Pledge-grade.svg": 66961,
	"./Pledge-img.svg": 41489,
	"./Pledge-left.svg": 20897,
	"./Pledge-left2.svg": 8933,
	"./Pledge-popup-icon.svg": 51661,
	"./Pledge-popup.svg": 35802,
	"./PointsMall-dui.svg": 39510,
	"./PointsMall-left.svg": 26713,
	"./PointsMall-line.svg": 28414,
	"./PriceSold-img.svg": 65446,
	"./PriceSold-right-fill.svg": 44911,
	"./RankingList-add-fill3.svg": 60036,
	"./RankingList-bj1.svg": 55459,
	"./RankingList-bj2.svg": 10687,
	"./RankingList-down.svg": 79969,
	"./RankingList-fill.svg": 90262,
	"./RankingList-fill1.svg": 94065,
	"./RankingList-fill2.svg": 85762,
	"./RankingList-one.svg": 21406,
	"./RankingList-three.svg": 97165,
	"./RankingList-two.svg": 63865,
	"./RankingList-up.svg": 51710,
	"./S.svg": 73472,
	"./SR.svg": 25966,
	"./SSR.svg": 43678,
	"./SellAndSold-add.svg": 9642,
	"./SellAndSold-bin.svg": 56177,
	"./SellAndSold-edit.svg": 48253,
	"./SellAndSold-img.svg": 52778,
	"./SellAndSold-line.svg": 7829,
	"./StructureGame-caret-down.svg": 33532,
	"./StructureGame-caret-up.svg": 35250,
	"./SynthesisDetails-photo1.svg": 72711,
	"./SynthesisDetails-photo2.svg": 71710,
	"./SynthesisDetails-photo3.svg": 27747,
	"./TradeCountdown-time.svg": 78950,
	"./UR.svg": 71070,
	"./Universe-dot.svg": 87180,
	"./Universe-oclock.svg": 10017,
	"./Universe-oclock2.svg": 82096,
	"./Universe-oclock3.svg": 63476,
	"./Universe-oclock4.svg": 82365,
	"./Universe-small1.svg": 85682,
	"./Universe-small2.svg": 41770,
	"./WantToBuy-img.svg": 65130,
	"./WantToBuy-small.svg": 47495,
	"./arrow-down.svg": 91129,
	"./arrow-left-white.svg": 86573,
	"./arrow-right-s-line.svg": 23672,
	"./arrow-right.svg": 95039,
	"./arrow-up-white.svg": 95479,
	"./arrow-up.svg": 70167,
	"./chat-check-fill.svg": 97482,
	"./checkbox-circle-fill.svg": 15591,
	"./close.svg": 97722,
	"./copy.svg": 13350,
	"./filter-3-line.svg": 51957,
	"./fluent_copy-20-filled.svg": 51569,
	"./gift-line.svg": 87364,
	"./hammer-line.svg": 77957,
	"./hf.svg": 43686,
	"./home-svg1.svg": 74336,
	"./icon.svg": 6400,
	"./icon2.svg": 73571,
	"./icon_boring_ape_index_gold_sands~iphone 1.svg": 87954,
	"./invite-1.svg": 28074,
	"./location.svg": 31015,
	"./mine-icon1.svg": 20060,
	"./mine-icon2.svg": 3261,
	"./mine-icon3.svg": 67165,
	"./mine-icon4.svg": 62183,
	"./mineicon1.svg": 52187,
	"./mineicon2.svg": 44983,
	"./mineicon3.svg": 74660,
	"./mineicon4.svg": 88630,
	"./mineicon5.svg": 66431,
	"./mineicon6.svg": 21351,
	"./mineicon7.svg": 5449,
	"./mineicon8.svg": 47324,
	"./myMiningCave.svg": 62726,
	"./nftDetail-emoj.svg": 77993,
	"./nftDetail-machine.svg": 15686,
	"./nftDetail-small.svg": 49280,
	"./onChainInformation-btn-img.svg": 93450,
	"./onChainInformation-logo.svg": 15029,
	"./onChainInformation-money1.svg": 11869,
	"./onChainInformation-money2.svg": 7139,
	"./onChainInformation-right-fill.svg": 34336,
	"./onChainInformation-yes.svg": 10083,
	"./qiu.svg": 51734,
	"./sd.svg": 56609,
	"./search.svg": 17302,
	"./share-box-line.svg": 3762,
	"./shine.svg": 87838,
	"./shopping.svg": 78373,
	"./starSourceKey-f.svg": 31420,
	"./stone.svg": 77279,
	"./tarbar/1-active.svg": 6228,
	"./tarbar/1.svg": 50867,
	"./tarbar/2-active.svg": 36670,
	"./tarbar/2.svg": 97292,
	"./tarbar/3-active.svg": 48994,
	"./tarbar/3.svg": 57844,
	"./tarbar/4-active.svg": 50530,
	"./tarbar/4.svg": 88424,
	"./tarbar/5-active.svg": 2400,
	"./tarbar/5.svg": 93415,
	"./time-fill.svg": 20852,
	"./tou.svg": 3991,
	"./wx.svg": 39198,
	"./zfb.svg": 83259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12994;